import counter from './counter/counter.component';
import dropdown from './dropdown/dropdown.component';
import pagination from './pagination.component';
import subMenu from './subMenu/menu.component';

export default angular.module('mpdx.common.pagination.module', [counter, dropdown, pagination, subMenu]).name;
